import { render, staticRenderFns } from "./GoodsListView.vue?vue&type=template&id=cf696896&"
import script from "./GoodsListView.vue?vue&type=script&lang=js&"
export * from "./GoodsListView.vue?vue&type=script&lang=js&"
import style0 from "./GoodsListView.vue?vue&type=style&index=0&module=true&lang=css&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports